var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog407(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_407"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_407",
    "data-name": 407,
    className: "cls-2",
    d: "M41.34,1.91C55.61-.81,64.92,16.13,69.55,28.64c6.27,17,12.4,66.25-13.38,69.64C30.63,101.65,21.3,49.87,25.61,30.11,26.82,24.6,31.35,3.81,41.34,1.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog407);
export default __webpack_public_path__ + "static/media/dog_407.a85b5d797c963e56edca6fb9c6c67bd8.svg";
export { ForwardRef as ReactComponent };